// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AppBarComponent-module__left-nav-container__xENv9{position:absolute;top:0px;height:100%;width:68px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"left-nav-container": "AppBarComponent-module__left-nav-container__xENv9"
};
export default ___CSS_LOADER_EXPORT___;
